module.exports = __webpack_public_path__ + "img/logo.1e7ad5db.png";